import { sanitizeTrackingValue } from '@/libs/userSource/trackingValue';

export type CookieSyncAction = { type: 'set'; value: string } | { type: 'remove' } | { type: 'noop' };

export function resolveSearchParamValue(
  searchParams: URLSearchParams,
  paramNames: readonly string[],
): string | undefined {
  for (const paramName of paramNames) {
    const normalized = sanitizeTrackingValue(searchParams.get(paramName));
    if (normalized) {
      return normalized;
    }
  }

  return undefined;
}

export function resolveTrackingCookieSyncAction(
  cookieRawValue: string | undefined,
  urlValue: string | undefined,
): CookieSyncAction {
  const cookieValue = sanitizeTrackingValue(cookieRawValue);

  if (urlValue && cookieValue !== urlValue) {
    return { type: 'set', value: urlValue };
  }

  if (!urlValue && cookieRawValue && !cookieValue) {
    return { type: 'remove' };
  }

  return { type: 'noop' };
}

export function shouldReplayEmailVerifiedEvent(
  pendingEventId: string | null,
  trackedEventId: string | null,
): boolean {
  return Boolean(pendingEventId && pendingEventId !== trackedEventId);
}

export function shouldTrackEmailVerifiedImmediately(
  willRedirect: boolean,
  trackedEventId: string | null,
  currentEventId: string,
): boolean {
  return !willRedirect && trackedEventId !== currentEventId;
}
